import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`I am a front-end developer with a passion for creating beautiful and functional user interfaces using React.js.`}</p>
    </blockquote>
    <p>{`I am currently exploring the world of web development and I am looking for a position where I can utilize my skills and experience to create beautiful and functional user interfaces. I also have a strong interest in blockchain development and I am currently learning about it.`}</p>
    <p>{`When I'm not pushing pixels, you'll find me playing video games or catching up on the latest movies and tv shows.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      